import { type TriggerRecord } from "@/shared/domain/triggers";
import { Goto } from "@/shared/navigation";

import { RobotoLinkHoverUnderline } from "../RobotoLinkHoverUnderline";

interface TriggerNameLinkProps {
  /** The trigger to link to */
  trigger: Pick<TriggerRecord, "name" | "trigger_id">;
  /** Extra class(es) for call-site typography, e.g. a table's cell style. */
  className?: string;
}

/**
 * A link to a trigger's page, labeled with the trigger's name and addressed
 * by its id. Use it when the trigger's record has been fetched, so the link
 * reaches a trigger that exists; {@link TriggerLink} takes a trigger id and
 * fetches the record first.
 */
export function TriggerNameLink({ trigger, className }: TriggerNameLinkProps) {
  return (
    <RobotoLinkHoverUnderline
      to={Goto.createTriggerRoute(trigger.trigger_id, trigger.name)}
      className={className}
    >
      {trigger.name}
    </RobotoLinkHoverUnderline>
  );
}
